export const mockedUnhandledRequestPattern = [
    'https://region1.google-analytics.com',
    'https://firestore.googleapis.com',
    'https://firebaseremoteconfig.googleapis.com/*',
    'https://apigw.integration.resurs.com/api/feature_toggles_service',
    'https://www.googletagmanager.com',
    'https://dm.quicksearch.se/quicksearch.websurvey.css',
    'http://fonts.googleapis.com/css?family=Lato',
    '/intake/v2/rum/events',
    'sentry.io/',
    'chrome-extension://*',
    '/manifest.json',
    '/favicon.ico',
    '.png',
    '.jpg',
    '.svg',
    '.ts',
];
